module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fc-Ge-Hc-Ia.e8a52278.png";